// ─────────────────────────────────────────────
//  Stars — reusable star rating display/input
//  Props:
//    value    — current rating (1–5)
//    onChange — if provided, becomes interactive
//    size     — font size of each star (px)
// ─────────────────────────────────────────────

export default function Stars({ value = 0, onChange, size = 28 }) {
  return (
    <div style={{ display: "flex", gap: 4 }}>
      {[1, 2, 3, 4, 5].map((s) => (
        <button
          key={s}
          onClick={() => onChange?.(s)}
          style={{
            background: "none",
            border: "none",
            cursor: onChange ? "pointer" : "default",
            fontSize: size,
            lineHeight: 1,
            padding: 0,
            color: s <= value ? "#FFBE0B" : "rgba(0,0,0,0.12)",
            transition: "transform 0.15s",
          }}
          onMouseEnter={(e) => {
            if (onChange) e.currentTarget.style.transform = "scale(1.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          ★
        </button>
      ))}
    </div>
  );
}
